import { get, post } from '../ApiUtil';

export type ChannelData = {
    id: string,
    name: string,
};

export type MemberData = {
    id: string,
    name: string,
    email: string,
    color: string,
    image: string,
};

export const slackExports = {
    invite: (body: {
        workspaceId: string,
        slackUsers: { id: string, email: string }[],
    }) => post<{ ok: boolean }>({
        path: '/slack.invite',
        body,
    }),

    channels: () => get<ChannelData[]>({
        path: '/slack.channels',
    }),

    members: (channelId: string) => get<MemberData[]>({
        path: '/slack.members',
        query: { channelId },
    }),

    info: () => get<{ token: boolean }>({
        path: '/slack.info',
    }),
};
